import { PUT_REDUX_PERMISSION_LIST } from '../../reducers/constants';

const putReduxPermissionList = (permissionList) => ({
  type: PUT_REDUX_PERMISSION_LIST,
  permissionList,
});
export default putReduxPermissionList;
